import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { RouterExtensions } from '@luggagehero/core';
import { TermsOfServiceConfig, UserModalBaseComponent } from '@luggagehero/features/user';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'lh-user-modal',
  templateUrl: './user-modal.component.html',
  styleUrls: ['./user-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UserModalComponent extends UserModalBaseComponent implements OnInit, OnDestroy {
  private router = inject(RouterExtensions);

  @ViewChild('loginModal', { static: true }) public loginModal: ModalDirective;
  public modalShown = false;

  public tosConfig: TermsOfServiceConfig = {
    textBeforeLink: 'ACCEPT_TERMS_PART_1',
    linkText: 'ACCEPT_TERMS_PART_2',
    linkUrl: 'https://luggagehero.com/terms-conditions/',
  };

  ngOnInit() {
    this.modalShown = true;
  }

  ngOnDestroy() {
    if (this.navigateHomeOnHide && !this.userService.isLoggedIn) {
      void this.router.navigate(['home']);
    }
  }
}
